module.exports = __webpack_public_path__ + "static/solutionLast-343e527bea014b229aed0718baf321d6.jpg";